/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });

import { intersectionObservation } from "./partials/intersectionObservation.js";

/*************************************************/
/* Partials                                      */
/*************************************************/

import { header } from "./partials/header.js";
import { language } from "./partials/language.js";
import { menu } from "./partials/menu.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchbar.js";
import { slider } from "./partials/slider.js";
import { video } from "./partials/video.js";
import { accordion } from "./partials/accordion.js";
import { accordionImages } from "./partials/accordion-images.js";
import { collapsedText } from "./partials/_collapsed-text.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";
import { visitorLocationSiteSwitch } from "./partials/_visitor-location-site-switch.js";


/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const body = document.querySelector('body');
    const bodyLoadingClass = 'is-loading';

    // Use a data attribute to identify the element
        const dataAttributeKey = "data-form-client-id";
        const formSubmittedElements = document.querySelectorAll(`[${dataAttributeKey}]`);
        formSubmittedElements.forEach((formSubmittedElement) => {
            const dataAttributeValue = formSubmittedElement.getAttribute(dataAttributeKey);
            const targetElement = document.querySelector(`[${dataAttributeKey}="${dataAttributeValue}"]`);
            const isOverlapping = document.querySelector(".image-text-item__text.image-text-item__text--overlapping");
            
            if (targetElement && isOverlapping) {
                window.scrollTo(0, targetElement.closest('.image-text-item__text').offsetTop);
            } else if (targetElement) {
                window.scrollTo(0, targetElement.closest('.image-text-item').offsetTop);
            }
        });

    //Add click listener to skip link
    document.querySelector('#skipLink').addEventListener('click',e => {
        document.querySelector('#mainContent').focus();
    });

    intersectionObservation();
    header(body);
    language();
    menu(body);
    search();
    searchbar(body);
    visitorLocationSiteSwitch();
    slider();
    accordion();
    collapsedText();
    modal(body, bodyLoadingClass);
    video();
    cookies();
    accordionImages();
});
